import { useCallback, useEffect, useState } from 'react';
import { systemicBreakpoints } from '../../styles/_variables';
import { calculateTimeLeft } from '../_utils';
import { DeadlineAlert } from '../../models/Html';
import { useAtom, useAtomValue } from 'jotai';
import { hideCloseBtnAtom, noBirthDateAtom, readWriteModalHistoryAtom } from '../../stores';
import * as amplitude from '@amplitude/analytics-browser';
import { consoleLogExceptProd } from '../../logging';
export var useInterval = function (callback, delay) {
    var call = useCallback(callback, [callback]);
    useEffect(function () {
        if (delay) {
            var id_1 = setInterval(call, delay);
            return function () {
                clearInterval(id_1);
            };
        }
    }, [call, delay]);
};
export var useIsMobile = function () {
    var _a = useState(false), isMobile = _a[0], setIsMobile = _a[1];
    useEffect(function () {
        setIsMobile(window.innerWidth < systemicBreakpoints.tablet);
        var handleResize = function () {
            setIsMobile(window.innerWidth < systemicBreakpoints.tablet);
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return isMobile;
};
export var useOnOutsideClick = function (ref, callback) {
    useEffect(function () {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);
};
export var useShowDeadline = function (deadTime, setAlertText, showCountDown, deadText) {
    useInterval(function () {
        if (deadTime !== null) {
            if (deadTime > new Date()) {
                var timeLeft = calculateTimeLeft(deadTime, true);
                if (showCountDown)
                    setAlertText(DeadlineAlert(timeLeft, deadText));
            }
            else {
                setAlertText(DeadlineAlert(undefined, deadText));
            }
        }
    }, (!!deadTime && deadTime) > new Date() ? 1000 : null);
};
export var useQueryStringParams = function () {
    var _a = useState(undefined), search = _a[0], setSearch = _a[1];
    useEffect(function () {
        if (typeof window !== 'undefined') {
            setSearch(window.location.search);
            var onPopState_1 = function () {
                setSearch(window.location.search);
            };
            window.addEventListener('popstate', onPopState_1);
            return function () {
                window.removeEventListener('popstate', onPopState_1);
            };
        }
    }, []);
    return new URLSearchParams(search);
};
export var removeWelcomeQueryStringParam = function () {
    var url = new URL(window.location.href);
    url.searchParams.delete('welcome');
    window.history.replaceState({}, '', url.href);
};
export var useKakaoInit = function (src) {
    var _a = useState(true), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    useEffect(function () {
        var script = document.querySelector("script[src=\"".concat(src, "\"]"));
        if (!script) {
            var script_1 = document.createElement('script');
            script_1.src = src;
            script_1.async = true;
            script_1.onload = function () {
                setIsLoading(false);
            };
            script_1.onerror = function (error) {
                setError(error);
            };
            document.body.appendChild(script_1);
        }
    }, [src]);
    return [isLoading, error];
};
export var useLockScroll = function (isShowModal) {
    var task = useAtomValue(readWriteModalHistoryAtom);
    useEffect(function () {
        if (isShowModal) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.removeProperty('overflow');
        }
        return function () {
            document.body.style.removeProperty('overflow');
        };
    }, [isShowModal, task]);
};
export var setAmplitudeUserId = function (user_id) {
    consoleLogExceptProd(true, 'user_id: ', user_id);
    amplitude.setUserId(user_id);
    consoleLogExceptProd(true, 'amplitude.getUserId(): ', amplitude.getUserId());
};
export var useInitializeHideCloseButton = function (hideCloseButtonFromClient) {
    var _a = useAtom(hideCloseBtnAtom), hideClose = _a[0], setHideClose = _a[1];
    useEffect(function () {
        setHideClose(hideCloseButtonFromClient);
    }, [hideCloseButtonFromClient]);
    return [hideClose, setHideClose];
};
export var useInitializeNoBirthDate = function (noBirthDateFromClient) {
    var _a = useAtom(noBirthDateAtom), noBirthDate = _a[0], setNoBirthDate = _a[1];
    useEffect(function () {
        setNoBirthDate(noBirthDateFromClient);
    }, [noBirthDateFromClient]);
};
//# sourceMappingURL=index.js.map